import { createAntdTheme } from "../adapters/antd.ts";
import { getTenantThemeDefinition } from "../tenants/registry.ts";
import type {
  AppThemeProvider,
  ResolvedTenantAppThemeConfig,
  ResolvedTenantThemeDefinition,
  TenantAppThemeConfig,
  ThemeContext,
} from "../core/types.ts";

export interface ResolveTenantThemeDefinitionOptions {
  context: ThemeContext;
}

const EMPTY_RESOURCES = {
  auth: {
    desktopLoginBackground: "",
    mobileLoginBackground: "",
  },
} as const;

const resolveAppProvider = (
  provider?: AppThemeProvider
): AppThemeProvider => provider ?? "antd";

const buildResolvedAppConfig = (
  appConfig?: TenantAppThemeConfig
): ResolvedTenantAppThemeConfig => ({
  provider: resolveAppProvider(appConfig?.provider),
  resources: {
    ...(appConfig?.resources ?? {}),
  },
});

export function resolveTenantThemeDefinition(
  options: ResolveTenantThemeDefinitionOptions
): ResolvedTenantThemeDefinition {
  const definition = getTenantThemeDefinition(options.context.tenantId);
  const appConfig = definition.apps[options.context.appId];
  const app = buildResolvedAppConfig(appConfig);

  return {
    context: options.context,
    definition,
    app,
    brandTheme: definition.base,
    resources: {
      auth: {
        desktopLoginBackground:
          app.resources.auth?.desktopLoginBackground ??
          EMPTY_RESOURCES.auth.desktopLoginBackground,
        mobileLoginBackground:
          app.resources.auth?.mobileLoginBackground ??
          EMPTY_RESOURCES.auth.mobileLoginBackground,
      },
    },
    antdTheme: createAntdTheme(definition.base, {
      layoutType: options.context.layoutType,
    }),
  };
}
